import { Element } from '../../../../../common/html/element'
import classes from './index.module.scss'

export const YearTabCommon = ({ tab, data, onClick }) => {
  return (
    <div className={classes.yearsTab}>
      {data.map((item) => (
        <Element
          key={item}
          className={classes.yearsTabItem}
          style={
            item === tab
              ? {
                  color: '#ffffff',
                  backgroundColor: '#2C73E8',
                }
              : {
                  color: '#191D25',
                  backgroundColor: '#ebebeb',
                }
          }
          onClick={() => onClick(item)}
        >
          {item}
        </Element>
      ))}
    </div>
  )
}
